import { useEffect, useRef } from 'react';
const usePrevious = value => {
  const ref = useRef(undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
export default usePrevious;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/typography/hooks/usePrevious.js
// module id = 3748
// module chunks = 0